jQuery(function ($) {
	new Swiper($(".auditoria__slider .swiper")[0], {
		slidesPerView: 2,
		slidesPerGroup: 2,
		spaceBetween: 0,
		grabCursor: true,
		speed: 700,
		navigation: {
			nextEl: $(".auditoria__slider").find(".swiper-arrow.next")[0],
			prevEl: $(".auditoria__slider").find(".swiper-arrow.prev")[0],
		},
		mousewheel: {
			releaseOnEdges: true,
			forceToAxis: true,
		},
		breakpoints: {
			768: {
				speed: 1000,
				slidesPerView: 5,
				slidesPerGroup: 5,
				spaceBetween: "28px",
			},

			1120: {
				slidesPerView: 6,
				slidesPerGroup: 6,
				spaceBetween: "48px",
			},
		},
	});
});
